(() => {
	"use strict";

	const MOBILE_BREAKPOINT = 992;
	const TAB_SCROLL_OFFSET = 16;

	const isMobile = () => window.innerWidth < MOBILE_BREAKPOINT;

	function initHeroSlider() {
		const root = document.getElementById("hero-global-container");
		if (!root || typeof Swiper === "undefined") return;

		const sliderElement = root.querySelector(".hero-swiper");
		if (!sliderElement || sliderElement.swiper) return;

		const nextBtn = root.querySelector(".hero-nav-btn-next");
		const prevBtn = root.querySelector(".hero-nav-btn-prev");
		const pagination = root.querySelector(".swiper-pagination-dots");

		function renderChips(container, statsString, accent) {
			if (!container || !statsString) return;
			if (container.dataset.renderedStats === statsString) {
				if (accent) {
					container.querySelectorAll(".hero-chip-metric").forEach((metricEl) => {
						metricEl.style.color = accent;
					});
				}
				return;
			}

			let stats;
			try {
				stats = JSON.parse(statsString);
			} catch (error) {
				console.error("Invalid hero slide stats:", error);
				return;
			}

			const fragment = document.createDocumentFragment();

			for (const [metric = "", label = ""] of stats) {
				const box = document.createElement("div");
				box.className = "hero-chip-box";

				const metricEl = document.createElement("div");
				metricEl.className = "hero-chip-metric";
				metricEl.textContent = metric;
				if (accent) metricEl.style.color = accent;

				const labelEl = document.createElement("div");
				labelEl.className = "hero-chip-label";
				labelEl.textContent = label;

				box.append(metricEl, labelEl);
				fragment.appendChild(box);
			}

			container.replaceChildren(fragment);
			container.dataset.renderedStats = statsString;
		}

		function syncSlideTheme(swiper) {
			// In loop mode the active slide may be a duplicate.
			const slide = swiper.slides[swiper.activeIndex];
			if (!slide) return;

			const { accent, deep, soft, glow, stats } = slide.dataset;
			const style = root.style;

			if (accent) style.setProperty("--hero-accent", accent);
			if (deep) style.setProperty("--hero-deep", deep);
			if (soft) style.setProperty("--hero-soft", soft);
			if (glow) style.setProperty("--hero-glow", glow);

			renderChips(slide.querySelector(".hero-chips-container"), stats, accent);
		}

		const swiper = new Swiper(sliderElement, {
			loop: true,
			speed: 700,
			effect: "fade",
			fadeEffect: { crossFade: true },
			allowTouchMove: isMobile(),
			autoplay: false,
			preventClicks: true,
			preventClicksPropagation: false,
			touchStartPreventDefault: false,
			pagination: pagination ? { el: pagination, clickable: true } : undefined,
			on: {
				init: syncSlideTheme,
				slideChange: syncSlideTheme
			}
		});

		const onResize = () => { swiper.allowTouchMove = isMobile(); };
		window.addEventListener("resize", onResize, { passive: true });

		nextBtn?.addEventListener("click", () => swiper.slideNext());
		prevBtn?.addEventListener("click", () => swiper.slidePrev());
	}

	function bindTabGroup({ tabSelector, panelSelector, panelAttr, onActivate }) {
		const container = document.querySelector(tabSelector)?.parentElement;
		if (!container) return;

		const handleClick = (event) => {
			const tab = event.target.closest(tabSelector);
			if (!tab || !container.contains(tab)) return;

			activateTab(tab);
		};

		function activateTab(tab) {
			container.querySelectorAll(tabSelector).forEach((item) => {
				const active = item === tab;
				item.classList.toggle("active", active);
				item.setAttribute("aria-selected", String(active));
			});

			if (panelSelector) {
				document.querySelectorAll(panelSelector).forEach((panel) => {
					panel.classList.toggle("active", panel.id === tab.dataset[panelAttr]);
				});
			}

			onActivate?.(tab);
		}

		container.addEventListener("click", handleClick);

		const initial =
			container.querySelector(`${tabSelector}.active`) ||
			container.querySelector(tabSelector);
		if (initial) activateTab(initial);

		return { activateTab };
	}

	function initModuleTabs() {
		if (!document.querySelector(".module-tab")) return;

		bindTabGroup({
			tabSelector: ".module-tab",
			panelSelector: ".mock",
			panelAttr: "module",
			onActivate: (tab) => {
				if (!isMobile()) return;

				const scroller = tab.closest(".module-tabs");
				if (!scroller) return;

				const scrollerRect = scroller.getBoundingClientRect();
				const tabRect = tab.getBoundingClientRect();

				scroller.scrollTo({
					left:
						scroller.scrollLeft +
						tabRect.left -
						scrollerRect.left -
						TAB_SCROLL_OFFSET,
					behavior: "smooth"
				});
			}
		});
	}

	function initCaseTabs() {
		if (!document.querySelector(".case-tab")) return;

		bindTabGroup({
			tabSelector: ".case-tab",
			panelSelector: ".case-panel",
			panelAttr: "case"
		});
	}

	function init() {
		initHeroSlider();
		initModuleTabs();
		initCaseTabs();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init, { once: true });
	} else {
		init();
	}
})();